import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GridFormComponent} from '..';

@Component({
  selector: 'gc-field-grid-form',
  templateUrl: './field-grid-form.component.html',
  styleUrls: ['./field-grid-form.component.css']
})
export class FieldGridFormComponent implements OnInit {

  constructor() { }
  f: GridFormComponent = null;

  @Input()
  get form(): any { return this.f; }
  set form(f: any) {
    this.f = f;
  }

  @Input() name: string;
  @Input() index = 0;

  @Output()
  changed: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {

  }

  onChange(value): void {
    this.changed.emit(value);
  }
}
